import React from 'react'
import Heading from '../../../components/heading/Heading'
import { HEADING } from '../../../components/heading/constants/constants'
import { useForm, Controller } from 'react-hook-form'
import styles from "./ChangePassword.styles"
import { VEC_ICON_NAME } from '../../../components/icons/constants'
import PasswordInput from '../../../components/input/passwordinput/PasswordInput'
import Button from '../../../components/button/Button'
import { BUTTON_TYPE } from '../../../components/button/constants'
import Icons from '../../../components/icons/Icons'
import { useEffect } from 'react'
import PasswordValidator from '../../../../libs/utility/validators/PasswordValidator'
import { Theme } from '../../../components/constants'
import { useDispatch, useSelector } from 'react-redux'
import { addNotifications } from '../../toaster/ToasterPortalSlice'
import { setNewPasswordValidations, componentKey, setChangePasswordSuccess } from './ChangePasswordSlice'
import { changeUserPassword } from './ChangePasswordSaga'
import Loadable from '../../../components/loadable/Loadable'
import { CHANGE_PASSWORD_PAGE_TITLE, CHANGE_PASSWORD_SUBMIT_TEXT, CHECK_MARK_ICON_SCALE, CONFIRM_PASSWORD_INPUT_NAME, CONFIRM_PASSWORD_TITLE, CURRENT_PASSWORD_INPUT_NAME, CURRENT_PASSWORD_TITLE, INVALID_PASSWORD_HEADER, INVALID_PASSWORD_TEXT, NEW_PASSWORD_INPUT_NAME, NEW_PASSWORD_TITLE, VALIDATION_PASSWORD_TITLE } from './constants'
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import { COMMON_LOADING_STATES, COMMON_LOADING_STATES_MESSAGE_MAP } from '../../constants/constants'
import { logoutUser } from '../../authentication/AuthenticationSaga'

export default function ChangePassword() {
    useGarbageCollector(componentKey)

	const { register, control, handleSubmit, watch, formState: { errors }, reset } = useForm();
	const { newPasswordValidations, loadingState, changePasswordSuccess } = useSelector((state) => state[componentKey])
	const dispatch = useDispatch();

	useEffect(() => {
		PasswordValidator.appendValidations([
			{
				validation: "At least 8 characters",
				condition: {
					type: "LENGTH",
					operator: "MINIMUM",
					value: 8,
				},
				result: false
			},
			{
				validation: "At least 1 upper case letter (A-Z)",
				condition: {
					type: "REGEX",
					value: '[A-Z]',
				},
				result: false
			},
			{
				validation: "At least 1 lower case letter (a-z)",
				condition: {
					type: "REGEX",
					value: '[a-z]',
				},
				result: false
			},
			{
				validation: "At least 1 special character",
				condition: {
					type: "REGEX",
					value: '[@$!%*#?&]',
				},
				result: false
			},
			{
				validation: "At least 1 number",
				condition: {
					type: "REGEX",
					value: '[0-9]',
				},
				result: false
			},
		]);
		dispatch(setNewPasswordValidations(PasswordValidator.getValidations()));
	}, [])

	const handleInputChange = (e, onChangeValidationController) => {
		const { name, value } = e.target;
		onChangeValidationController(value);
	}

	const newPassword = watch('newPassword');

	useEffect(() => {
		validateNewPassword(newPassword);
	}, [newPassword])

	const validateConfirmPassword = (value) => {
		if (newPassword !== value) {
			return 'Passwords do not match';
		}
		return true;
	};

	useEffect(() => {
		if(changePasswordSuccess){
			reset();
			dispatch(setChangePasswordSuccess(false))
			dispatch(logoutUser());
		}
	}, [changePasswordSuccess])

	const validateNewPassword = (value) => {
		const valueString = value ?? "";
		const validationResult = PasswordValidator.validate(valueString);
		dispatch(setNewPasswordValidations([...validationResult]));
	};

	const handleFormSubmit = (value) => {
		if (newPasswordValidations.find(val => val.result === false)) {
			dispatch(addNotifications({ heading: INVALID_PASSWORD_HEADER, message: INVALID_PASSWORD_TEXT }))
			return
		}
		dispatch(changeUserPassword(value));
	}
	return (
			<div style={styles.mainContainer}>
				<div style={styles.leftInnerContainer}>
					<Heading type={HEADING.H1}>{CHANGE_PASSWORD_PAGE_TITLE}</Heading>
					<div style={styles.inputContainer}>
						<span>{CURRENT_PASSWORD_TITLE}</span>
						<Controller
							control={control}
							name={CURRENT_PASSWORD_INPUT_NAME}
							defaultValue={''}
							rules={{
								required: `Current Password cannot be empty`,
							}}
							render={({ field: { value, onChange } }) => (
								<PasswordInput
									name={CURRENT_PASSWORD_INPUT_NAME}
									type="password"
									placeHolder='Password'
									value={value}
									onChangeCb={(e) => handleInputChange(e, onChange)}
								/>
							)}
						/>
						{errors.currentPassword && <span style={styles.errorMessage}>{errors.currentPassword.message}</span>}
					</div>
					<div style={styles.inputContainer}>
						<span>{NEW_PASSWORD_TITLE}</span>
						<Controller
							control={control}
							name={NEW_PASSWORD_INPUT_NAME}
							defaultValue={''}
							rules={{
								required: "Password cannot be empty",
							}}
							render={({ field: { value, onChange } }) => (
								<PasswordInput
									name={NEW_PASSWORD_INPUT_NAME}
									type="password"
									placeHolder='Password'
									value={value}
									onChangeCb={(e) => handleInputChange(e, onChange)}
								/>
							)}
						/>
						{errors.newPassword && <span style={styles.errorMessage}>{errors.newPassword.message}</span>}
					</div>
					<div style={styles.inputContainer}>
						<span>{CONFIRM_PASSWORD_TITLE}</span>
						<Controller
							control={control}
							name={CONFIRM_PASSWORD_INPUT_NAME}
							defaultValue={''}
							rules={{
								required: "Password cannot be empty",
								validate: validateConfirmPassword,
							}}
							render={({ field: { value, onChange } }) => (
								<PasswordInput
									name={CONFIRM_PASSWORD_INPUT_NAME}
									type="password"
									placeHolder='Password'
									value={value}
									onChangeCb={(e) => handleInputChange(e, onChange)}
								/>
							)}
						/>
						{errors.confirmPassword && <span style={styles.errorMessage}>{errors.confirmPassword.message}</span>}
					</div>
					<div style={styles.submitButton}>
						<Loadable currentState={loadingState.state} loadingStates={[COMMON_LOADING_STATES.GENERAL_LOADING]} messageMap={COMMON_LOADING_STATES_MESSAGE_MAP} isNewLoadable={true} isFullWidth={false}>
							<Button type={BUTTON_TYPE.PRIMARY} onClickCb={handleSubmit(handleFormSubmit)}>{CHANGE_PASSWORD_SUBMIT_TEXT}</Button>
						</Loadable>
					</div>
				</div>
				<div style={styles.rightInnerContainer}>

					<Icons familyName={'vec'} iconName={VEC_ICON_NAME.CHANGE_PASSWORD_PAGE_VECTOR} />
					<Heading type={HEADING.H1}>{VALIDATION_PASSWORD_TITLE}</Heading>

					{newPasswordValidations.map((validated) =>
						<div style={styles.validationColumn}>
							{validated.result ?
								<Icons style={styles.checkMark} familyName={'vec'} iconName={VEC_ICON_NAME.GREEN_CHECK_MARK} transformScale={CHECK_MARK_ICON_SCALE} />
								:
								<span>—</span>}
							<span style={styles.validationText}>{validated.validation}</span>
						</div>)}

				</div>
			</div>
	)
}